import React, { useState } from 'react';

import CardView from '../common/CardView/CardView';
import NavTabGroup from '../common/NavTabGroup/NavTabGroup';

import LogsIndex from './LogsIndex';

type LogsPanelProps = {
  pipelineID: string,
  isAnomalyDetectionEnabled: boolean,
}

export const LogsPanel = ({ pipelineID, isAnomalyDetectionEnabled = false }: LogsPanelProps) => {
  const [selectedLogTab, setSelectedLogTab] = useState('Audit Log');
  const [tabLoading, setTabLoading] = useState(false);

  const onTabSelected = (tabVal: string) => {
    setSelectedLogTab(tabVal);
    setTabLoading(true);
  };

  const tabOptions = [
    {
      value: 'Audit Log',
    },
    {
      value: 'Anomaly Log',
      disabled: !isAnomalyDetectionEnabled,
    }
  ]

  return (
    <CardView className="pt-2 px-8 pb-0 mb-4 h-96" disableFullHeight>
      <NavTabGroup
        options={tabOptions}
        selectedTab={selectedLogTab}
        onTabSelected={onTabSelected}
      />
      <LogsIndex
        isHidden={selectedLogTab !== 'Audit Log'}
        pipelineID={pipelineID}
        tabLoading={tabLoading}
        onLogsLoaded={() => setTabLoading(false)}
      />
      <LogsIndex
        isHidden={selectedLogTab !== 'Anomaly Log'}
        pipelineID={pipelineID}
        tabLoading={tabLoading}
        useAnomalyLogs={isAnomalyDetectionEnabled}
        onLogsLoaded={() => setTabLoading(false)}
      />
    </CardView>
  );
};
export default LogsPanel;
